import { Box, Divider, SxProps, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { flexCenter } from '../../../commonUI/cssClasses';
export interface MapButtonMenuPopupProps {
  title: string;
  children: ReactNode;
}

export const MapButtonMenuPopup: React.FC<MapButtonMenuPopupProps> = ({
  title,
  children,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const titleStyles: SxProps = {
    width: '100%',
    ...flexCenter,
    pb: '0.5rem',
    mt: '1rem',
    color: theme.colors.darkTheme.grey.muted,
  };

  const dividerElement = (
    <Divider
      sx={{
        width: '100%',
        bgcolor: theme.colors.darkTheme.grey.muted,
        mb: '1rem',
      }}
    />
  );

  const menuContent = (
    <Box
      sx={{
        width: '100%',
        ...flexCenter,
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      <Typography variant='h6' sx={{ ...titleStyles }}>
        {t(title, { ns: 'ranch-view' })}
      </Typography>
      {dividerElement}
      {children}
    </Box>
  );

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: '1rem',
      }}
    >
      {menuContent}
    </Box>
  );
};

export default MapButtonMenuPopup;
